import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Smartphone } from 'lucide-react';
const imageBonuses = [{
  img: 'https://cdn.magicpatterns.com/uploads/1WdQmUeP6mFQ3mC4ujkHRd/BONUS_1.png',
  alt: 'Bono 1 - Guía de velas decorativas'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/fz55A3EuBjBWKhQYDrN3RB/BONUS_2.png',
  alt: 'Bono 2 - Guía de piezas con espejos'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/ucfcKLy8somgmkbasAcJ4d/BONUS_3.png',
  alt: 'Bono 3 - +100 ideas de piezas decorativas'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/dWLWXh2mM5oj4h6PhbasUT/BONUS_4.png',
  alt: 'Bono 4 - +100 ideas de souvenirs'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/i97YTPBVUWMzTTP7dvfXYn/BONUS_5.png',
  alt: 'Bono 5 - Guía de emprendimiento'
}];
export function Bonuses() {
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 bg-deco-sage/10 relative overflow-hidden" data-id="element-25">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-deco-sage/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-26"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-deco-terra/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-27"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-28">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10" data-id="element-29">
          <div className="inline-flex items-center justify-center gap-2 bg-deco-card text-deco-terra px-5 py-2 rounded-full font-bold text-xs sm:text-sm mb-6 border border-deco-terra/20 shadow-sm" data-id="element-30">
            <Gift size={16} data-id="element-31" />
            <span className="uppercase tracking-wider" data-id="element-32">
              Bonos incluidos solo por hoy
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold leading-tight" data-id="element-33">
            Además, te llevas bonos de regalo
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-34">
            Recibís recursos extra para crear productos más completos y aumentar
            tus posibilidades de venta.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6 lg:gap-8 mb-8" data-id="element-35">
          {imageBonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`bg-deco-card rounded-[1.5rem] sm:rounded-[2rem] overflow-hidden shadow-md border-2 border-white aspect-[3/4] flex items-center justify-center relative group ${i === 4 ? 'col-span-2 lg:col-span-1 w-1/2 lg:w-full mx-auto' : ''}`} data-id="element-36">
              <img src={bonus.img} alt={bonus.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-37" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}